var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "min-h-screen flex"
  }, [_c('div', {
    on: {
      "click": function ($event) {
        _vm.showHelp = true;
      }
    }
  }, [_c('help-button')], 1), _vm._v(" "), _c('help', {
    attrs: {
      "show-help": _vm.showHelp
    },
    on: {
      "close": function ($event) {
        _vm.showHelp = false;
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "hidden lg:block w-1/4 bg-white h-screen"
  }, [_c('router-link', {
    staticClass: "flex items-center mt-16 ml-16",
    attrs: {
      "to": {
        name: 'Login'
      }
    }
  }, [_c('icon', {
    staticClass: "text-indigo-600",
    attrs: {
      "name": "logo-neopass"
    }
  })], 1), _vm._v(" "), _c('illustration', {
    staticClass: "absolute my-auto inset-0 px-8 py-2 w-1/4",
    attrs: {
      "name": "check_validation"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-1 flex flex-col w-3/4 bg-gray-200 rounded-tl-large justify-center py-12 px-4 sm:px-6 lg:flex-none lg:pl-20 xl:pl-24"
  }, [_c('div', {
    staticClass: "mx-auto lg:ml-32 w-full max-w-lg"
  }, [_c('h1', {
    staticClass: "text-left text-4xl font-normal leading-8 text-gray-900"
  }, [_vm._v("\n                Mot de passe perdu\n            ")]), _vm._v(" "), _c('p', {
    staticClass: "mt-4 text-base font-normal text-gray-600"
  }, [_vm._v("\n                Veuillez saisir votre adresse mail.\n            ")]), _vm._v(" "), _c('p', {
    staticClass: "text-base font-normal text-gray-600"
  }, [_vm._v("\n                Un lien de réinitialisation vous sera envoyé.\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "mt-5"
  }, [_c('form', {
    attrs: {
      "action": "#"
    },
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        return _vm.requestResetPassword.apply(null, arguments);
      }
    }
  }, [_c('div', {
    staticClass: "rounded-md shadow-sm"
  }, [_c('input-text', {
    attrs: {
      "id": "email",
      "type": "email",
      "name": "email",
      "libelle": "",
      "value": _vm.form.email,
      "big": true,
      "placeholder": "Adresse Email",
      "required": true
    },
    on: {
      "input": function (newValue) {
        _vm.form.email = newValue;
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "mt-8 space-y-4 flex flex-col items-center sm:space-y-0 sm:flex-row"
  }, [_c('big-action-button', {
    attrs: {
      "border-color": "border-transparent",
      "text-color": "text-white",
      "bg-color": "bg-pink-600",
      "bg-color-square": "bg-pink-600",
      "icon-color": "text-white",
      "libelle": "CONTINUER",
      "spinner": _vm.loading,
      "right": true,
      "icon": "arrow-right_1",
      "type-shadow": "shadow-pink"
    }
  })], 1), _vm._v(" "), _vm.success ? _c('p', {
    staticClass: "mt-6 text-xs font-medium text-green-600"
  }, [_vm._v("\n                        " + _vm._s(_vm.success) + "\n                    ")]) : _vm._e(), _vm._v(" "), _c('v-errors', {
    staticClass: "mt-6 text-xs font-medium text-red-500",
    attrs: {
      "errors": Object.assign({}, _vm.errors)
    }
  })], 1)])])])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }